import React from 'react';

interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetError }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-4">
      <div className="max-w-md w-full text-center p-8 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700">
        <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg 
            className="w-8 h-8 text-red-600 dark:text-red-400" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        
        <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">
          Something went wrong
        </h2>
        
        <p className="text-slate-500 dark:text-slate-400 mb-6">
          An unexpected error occurred. Our team has been notified.
        </p>

        {error && (
          <details className="mb-6 text-left">
            <summary className="text-sm text-slate-400 cursor-pointer hover:text-slate-600">
              Error details
            </summary>
            <pre className="mt-2 p-3 bg-slate-100 dark:bg-slate-900 rounded text-xs text-red-600 dark:text-red-400 overflow-auto max-h-32">
              {error.message}
            </pre>
          </details>
        )}

        <div className="flex flex-col gap-3">
          {resetError && (
            <button
              onClick={resetError}
              className="w-full py-3 px-6 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors"
            >
              Try Again
            </button>
          )}
          
          <button
            onClick={() => window.location.reload()}
            className="w-full py-3 px-6 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-200 font-semibold rounded-lg hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors"
          >
            Reload Page
          </button>
        </div>

        <p className="mt-6 text-xs text-slate-400 dark:text-slate-500">
          If this problem persists, please contact support.
        </p>
      </div>
    </div>
  );
};

export default ErrorFallback;
